export default {
  clearSkillState: ({ commit }) => commit("CLEAR_SKILL_STATE"),

  store: ({ commit }, payload) => commit("store", payload),

  delete: ({ commit }, payload) => commit("delete", payload),

  index: ({ commit }, payload) => commit("index", payload)
};
